module.exports = __webpack_public_path__ + "static/media/George-Muncey-Film-Photography.771039d5.jpg";